// src/components/GoogleTagManager.tsx
import { useEffect, useRef } from 'react';
import { loadGTM } from '@/lib/gtmSnippet';
import analyticsConfig from '@/config/gtmConfig';
import usePageTracking from '@/hooks/usePageTracking';

interface GoogleTagManagerProps {
  gtmId?: string;
}

const GoogleTagManager = ({
  gtmId = analyticsConfig.gtmId,
}: GoogleTagManagerProps) => {
  const isInitialized = useRef(false);

  // Use our custom hook for page tracking (handles duplicates)
  usePageTracking();

  // Initialize GTM only once when component first mounts
  useEffect(() => {
    // Check if we should initialize GTM
    if (!isInitialized.current && analyticsConfig.isEnabled) {
      // Initialize script (header script only)
      loadGTM(gtmId);

      // Mark as initialized
      isInitialized.current = true;
    }
  }, [gtmId]);

  // This component no longer renders anything
  return null;
};

export default GoogleTagManager;
